module.exports = __webpack_public_path__ + "img/tarj1-2.787c8118.png";